import { Injectable } from "@angular/core";
import { RelatorioHorarioHorarioAfericaoDTO, RelatorioHorarioHorarioAfericaoListDTO } from "app/model/dtos/mob/relatorioHorarioAfericao.dto";
import { HttpGet, HttpPost, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";
import { HorarioAfericaoDTO } from '../../model/dtos/mob/horario-afericao.dto';

@Injectable()
export class HorarioAfericaoController {
    constructor() { }

    async sync(): Promise<JSON> {
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/horario/afericoes/sync',
                    environment: environment
                }),
            }),
            new HttpResponse(
                new JSONData()
            )
        );

        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<HorarioAfericaoDTO>> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/relatoriohorarios',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<HorarioAfericaoDTO>()
            )
        );
        return await quark.call()
    }
    
    async findRelatorio(filtros?: IFilter): Promise<Array<RelatorioHorarioHorarioAfericaoListDTO>> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/relatoriohorarios',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<RelatorioHorarioHorarioAfericaoDTO>()
            )
        );
        return await quark.call()
    }

    async get(cdControle: number):Promise<HorarioAfericaoDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/horario/afericoes/:cdControle',
                    environment: environment,
                    pathParams: new JSONData({ cdControle: cdControle})
                }),
            }),
            new HttpResponse(
                new HorarioAfericaoDTO()
            )
        );

        return await quark.call();
    } 

    async relatorioHorarioAfericao(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/relatoriohorarios/relatorio',
                    environment: environment,
                    filter: filtros
                }),
				responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }
}